import { render } from "./SongCard.vue?vue&type=template&id=6c915f76"
import script from "./SongCard.vue?vue&type=script&lang=js"
export * from "./SongCard.vue?vue&type=script&lang=js"

import "./SongCard.vue?vue&type=style&index=0&id=6c915f76&lang=css"
script.render = render

export default script